
// SVG Icon: compass-rotation-marker
export default { id: "terriajs-compass-rotation-marker" };
export const id = "terriajs-compass-rotation-marker";
export const name = "compass-rotation-marker";
